import { render, staticRenderFns } from "./SurveyApplet.vue?vue&type=template&id=64364263&scoped=true&"
import script from "./SurveyApplet.vue?vue&type=script&lang=js&"
export * from "./SurveyApplet.vue?vue&type=script&lang=js&"
import style0 from "./SurveyApplet.vue?vue&type=style&index=0&id=64364263&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64364263",
  null
  
)

export default component.exports